// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  InstantSearchApi.beforeCall = function(searchTerm) {
    /* Change the params before calling api */
    Globals.instantSearchQueryParams.return_all_currency_fields = false;
  }
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
    // If the multi-currency feature is enabled, update the product price
    this.prepareSuggestionProductPriceData();
    // Check on sale
    var onSale = this.data.compare_at_price_min > this.data.price_min;
    // Format price
    var price = Utils.formatMoney(this.data.price_min);
    var compareAtPrice = '';
    if (this.data && this.data.compare_at_price_min) {
      compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
      if (Settings.getSettingValue('search.removePriceDecimal')) {
        price = Utils.removeDecimal(price);
        compareAtPrice = Utils.removeDecimal(compareAtPrice);
      }
    }

    if (onSale && swLayout(this.data) == "Grouped" || onSale && swLayout(this.data) == "Grouped-Fits") {
      let option_arr = []
      this.data.variants.forEach((element) => {
        if (element.option1 == 'Top' && element.available == true || element.option1 == 'Bottom' && element.available == true){
          option_arr.push(element.option1)
        }
      });
      if (option_arr.includes('Top') == true && option_arr.includes('Bottom') != true || option_arr.includes('Top') != true && option_arr.includes('Bottom') == true) {
        compareAtPrice = Utils.removeDecimal(Utils.formatMoney(this.data.compare_at_price_min));
      } else {
        compareAtPrice = Utils.removeDecimal(Utils.formatMoney(this.data.compare_at_price_min + this.data.compare_at_price_max));
      }
    } else if (onSale) {
      compareAtPrice = Utils.removeDecimal(Utils.formatMoney(this.data.compare_at_price_min));
    }

    let option_arr = []
    this.data.variants.forEach((element) => {
      if (element.option1 == 'Top' && element.available == true || element.option1 == 'Bottom' && element.available == true) {
        option_arr.push(element.option1)
      }
    });
    if (option_arr.includes('Top') == true && option_arr.includes('Bottom') != true || option_arr.includes('Top') != true && option_arr.includes('Bottom') == true) {
      if (data.price_min == 0) {
        price = Utils.removeDecimal(Utils.formatMoney(this.data.price_max));
      } else {
        price = Utils.removeDecimal(Utils.formatMoney(this.data.price_min));
      }
    } else if (swLayout(this.data) == "Grouped" || swLayout(this.data) == "Grouped-Fits") {
      price = Utils.removeDecimal(Utils.formatMoney(this.data.price_min + this.data.price_max));
    } else {
      price = Utils.removeDecimal(Utils.formatMoney(this.data.price_min));
    }
  
    // Build Price
    var result = '';
    if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
      if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
      } else {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
      }
    }
    return result
      .replace(/{{regularPrice}}/g, price)
      .replace(/{{compareAtPrice}}/g, compareAtPrice);
  }
  
  InstantSearchResultItemProduct.prototype.getTemplate = function (tempType) {
		switch (tempType) {
			case InstantSearchResultItemProduct.tempType.IMAGE:
				return `
					<div class="{{class.searchSuggestion}}-left">
						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`.trim();
			case InstantSearchResultItemProduct.tempType.SKU:
				return `
					<p class="{{class.searchSuggestion}}-product-sku">{{sku}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.VENDOR:
				return `
					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
					</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE_SALE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<s>{{compareAtPrice}}</s>&nbsp;
						<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>
					</p>
				`.trim();
			default:
				return `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								{{itemProductVendor}}
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
								{{itemProductSku}}
								{{itemProductPrice}}
							</div>
						</a>
					</li>
				`.trim();
		}
	}
  
  InstantSearchApi.beforeCall = function(searchTerm) {
    /* Change the params before calling api */
      Globals.instantSearchQueryParams.sort = 'created-descending';
  }
})();